import React from 'react'

import { ContainerProps } from './types'

import RangeSlider from './index.presentational'

const RangeSliderContainer: React.FC<ContainerProps> = ({
  marks,
  onChange: onChangeProp,
  value,
  ...props
}): React.ReactElement => {
  const min = Math.min(...Object.keys(marks).map(Number))
  const max = Math.max(...Object.keys(marks).map(Number))

  const onChange = (value: number) => {
    onChangeProp && onChangeProp({ target: { value } })
  }

  return React.createElement(
    RangeSlider,
    {
      ...props,
      marks,
      min,
      max,
      onChange,
      value,
    },
  )
}

export * from './types'

export default RangeSliderContainer
